import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// init({
//   dsn: environment.sentryDsn,
//   environment: environment.env,
//   release: `${packageJson.name}@${packageJson.version}`,
//   integrations: [
//     new BrowserTracing({
//       tracingOrigins: ['::1'],
//     }),
//   ],
//   tracesSampleRate: 1.0,
//   beforeSend: (event, hint) => {
//     if (environment.env != 'prod') {
//       return null;
//     }
//     return event;
//   },
// });

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
